import { render, staticRenderFns } from "./CollapseDefault.vue?vue&type=template&id=85215638&"
import script from "./CollapseDefault.vue?vue&type=script&lang=js&"
export * from "./CollapseDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports